if (!customElements.get('rolloffs-equipment-intro')) {
  customElements.define('rolloffs-equipment-intro', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const source = this.querySelector('template').content.cloneNode(true);
      source.querySelectorAll('script,style,link,meta,iframe').forEach(node => node.remove());
      const headings = ['details','description','features','feature','specifications','specification','specs','performance','options','manuals','manual','brochures','brochure','drawings','drawing','available colors','available colours','colors','colours','get a quote'];
      const firstSection = [...source.querySelectorAll('h2,h3')].find(node => headings.includes(node.textContent.trim().replace(/:$/, '').toLowerCase()));
      const range = document.createRange();
      range.selectNodeContents(source);
      if (firstSection) range.setEndBefore(firstSection);
      const intro = range.cloneContents();
      intro.querySelectorAll('a[href],img[src]').forEach(node => {
        const attr = node.tagName === 'IMG' ? 'src' : 'href';
        try {
          const url = new URL(node.getAttribute(attr), 'https://rolloffs.net/');
          if (['https:', 'http:'].includes(url.protocol)) node.setAttribute(attr,url.href);
          else node.removeAttribute(attr);
        } catch { node.removeAttribute(attr); }
      });
      this.querySelector('[data-equipment-intro]').replaceChildren(intro);
      this.hidden = !this.querySelector('[data-equipment-intro]').textContent.trim() && !this.querySelector('[data-equipment-intro] img');
    }
  });
}

